import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 15l9 6l9 -6l-9 -6l-9 6","key":"svg-0"}],["path",{"d":"M3 9l9 6l9 -6l-9 -6l-9 6","key":"svg-1"}],["path",{"d":"M3 9l0 6","key":"svg-2"}],["path",{"d":"M21 9l0 6","key":"svg-3"}],["path",{"d":"M12 3l0 6","key":"svg-4"}],["path",{"d":"M12 15l0 6","key":"svg-5"}]]

const IconBrandCodepen = createReactComponent('outline', 'brand-codepen', 'BrandCodepen', __iconNode);

export default IconBrandCodepen;